// ThemeContext.tsx
import React, { createContext, useContext, useState, useMemo } from 'react';
import { Theme, lightTheme, darkTheme } from '../utils/themes';

type ThemeContextType = {
  theme: Theme;
  toggleTheme: () => void;
};

const ThemeContext = createContext<ThemeContextType>({
  theme: darkTheme,
  toggleTheme: () => { },
});

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(() => {
    const savedTheme = localStorage.getItem("appTheme");
    // return savedTheme === "dark" ? darkTheme : lightTheme;
    if (savedTheme === "dark") return darkTheme;
    if (savedTheme === "light") return lightTheme;

    if (typeof window !== 'undefined' && window.matchMedia) {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      return prefersDark ? darkTheme : lightTheme;
    }

    return lightTheme;
  });

  const toggleTheme = () => {
    const newTheme = theme === lightTheme ? darkTheme : lightTheme;
    localStorage.setItem("appTheme", newTheme === lightTheme ? "light" : "dark");
    setTheme(newTheme);
  };

  const contextValue = useMemo(() => ({ theme, toggleTheme }), [theme]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  return useContext(ThemeContext);
};